export default "__VITE_ASSET__BbLjbefM__"